module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hyJ06"))).then(() => parcelRequire('1iHdE'));